export default __webpack_public_path__ + "static/media/PowerGrotesk-Heavy.67c5d594.woff2";